import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { removeWriteoffNoteAction as removeWriteoffNote } from '../../../../../../services/WriteoffService/slice';
import { WriteoffNoteView } from '../../../../../../services/WriteoffService/types/writeoffTypes';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

export interface UseNoteActionsOptions {
  note: WriteoffNoteView | null;
  onClose: () => void;
}

export interface UseNoteActionsReturn {
  canDelete: boolean;
  handleDelete: () => void;
}

export function useNoteActions({ note, onClose }: UseNoteActionsOptions): UseNoteActionsReturn {
  const dispatch = useAppDispatch();
  const { data: userProfile } = useGetMyProfileQuery();

  const canDelete = useCallback((): boolean => {
    if (!note || !userProfile) return false;
    const currentUserIdentity = userProfile.identity || userProfile.name;
    return note.addedBy === currentUserIdentity;
  }, [note, userProfile]);

  const handleDelete = useCallback(() => {
    if (note?.id) {
      const confirmed = window.confirm(
        'Are you sure you want to delete this note? This action cannot be undone.'
      );
      if (confirmed) {
        dispatch(removeWriteoffNote(note.id));
        onClose();
      }
    }
  }, [note, dispatch, onClose]);

  return {
    canDelete: canDelete(),
    handleDelete,
  };
}
